module.exports = __webpack_public_path__ + "static/media/settings_grey.2c4c13e3.svg";